import { SystemPermissionModel } from '../../models/SystemPermissionModel';
import { ActionBase } from '../../../core/store/action/ActionBase';

export const ADD_PERMISSION_TO_ROLE = '[Security] Role Add Permission';

export class AddPermissionToRoleAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = ADD_PERMISSION_TO_ROLE;

  constructor(public payload: { roleKey: string, permission: SystemPermissionModel }) { }
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/AddPermissionToRoleAction.ts